// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__hUJbl","copyright":"Footer_copyright__Jk4FG"};